"use client";

import { c as _c } from "react/compiler-runtime";
import { publicEnv } from "@/config/env";
import { useEffect, useState } from "react";
const CURRENT = publicEnv.VERSION!; // baked into the bundle
const SHOW_NEW_VERSION_TOAST_PARAM = "showNewVersionToast";
const shouldForceShowNewVersionToast = () => globalThis.window !== undefined && new URLSearchParams(globalThis.location.search).get(SHOW_NEW_VERSION_TOAST_PARAM) === "true";
export function useIsVersionStale(t0) {
  const $ = _c(3);
  const interval = t0 === undefined ? 120000 : t0;
  const [stale, setStale] = useState(shouldForceShowNewVersionToast);
  let t1;
  let t2;
  if ($[0] !== interval) {
    t1 = () => {
      if (shouldForceShowNewVersionToast()) {
        setStale(true);
        return;
      }
      let id;
      const check = async function check() {
        try {
          const {
            version
          } = await fetch("/api/version", {
            cache: "no-store"
          }).then(_temp);
          setStale(version !== CURRENT);
        } catch {}
      };
      check();
      id = setInterval(check, interval);
      const onFocus = () => check();
      globalThis.addEventListener("focus", onFocus);
      return () => {
        clearInterval(id);
        globalThis.removeEventListener("focus", onFocus);
      };
    };
    t2 = [interval];
    $[0] = interval;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  return stale;
}
function _temp(r) {
  return r.json();
}